import React from "react";
import ReactDOM from "react-dom";
import config from "../config";

export default function setupABTasty() {
    if (config.ENV === "prod") {
        let ABTastyScript = document.createElement("script");

        ABTastyScript.type = "text/javascript";
        ABTastyScript.src =
            "https://try.abtasty.com/b1f264c8c9d95b665b02d34272c85fd3.js";

        const ABTastyScriptTag = document.head.appendChild(ABTastyScript);
        ReactDOM.render("", ABTastyScriptTag);
    }
}
